import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useAlert } from 'react-alert';
import { FaSearch, FaCheck, FaTimes, FaTrash } from 'react-icons/fa';

const AddItemBase = ({ 
  type,
  group,
  onClose,
  handleSuccess,
  renderSamplesColumn,
  renderItemsList,
  renderSelectedList,
  handleSubmit,
  selectedItems
}) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      show={true}
      onHide={onClose}
    >
      <Modal.Body>
        <div className="add-cont colflex-display">
          <label className="addcont-head" style={{ margin: 0 }}>{group.name}</label>
          {group.description && <span style={{ color: '#000' }}>{group.description}</span>}
          <hr style={{ border: "1px solid #ccc", margin: 0 }} />
          <div className="additem-container">
            {renderSamplesColumn && renderSamplesColumn()}
            
            <div className="items-column">
              <div className="items-header">
                {!showSearch ? (
                  <div className="header-content" style={{ display: 'flex', justifyContent: "space-between" }}>
                    <span>
                      Available {type === 'feature' ? 'Policies' : `${type}s`}
                    </span>
                    <FaSearch
                      style={{ color: '#fff' }}
                      className="toggle-search"
                      onClick={() => setShowSearch(true)}
                    />
                  </div>
                ) : (
                  <div className="search-container">
                    <input
                      type="text"
                      placeholder={`Search ${type === 'feature' ? 'policies' : type + 's'}...`}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      autoFocus
                    />
                    <FaTimes
                      style={{ color: '#fff' }}
                      className="toggle-search"
                      onClick={() => {
                        setShowSearch(false);
                        setSearchTerm('');
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="items-list">
                {renderItemsList(searchTerm)}
              </div>
            </div>
            
            <div className="selected-column">
              <div className="selected-header">
                Selected {type === 'feature' ? 'Policies' : `${type}s`}
              </div>
              <div className="selected-list">
                {renderSelectedList()}
              </div>
            </div>
          </div>

          <div className="action-buttons">
            <button className='cancel-btn' onClick={onClose}>
              Cancel
            </button>
            <button
              className='save-btn'
              onClick={handleSubmit}
              disabled={selectedItems.length === 0}
            >
              Save
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddItemBase;